import React from "react";
import "./Service.scss";
import {Redirect, Route, Switch} from "react-router-dom";
import {AfterSaleService} from "./components/AfterSaleService/AfterSaleService";
import {QAService} from "./components/QAService/QAService";
import {CaseShow} from "./components/CaseShow";

export function Service() {

    return (
        <Switch>
            <Route exact path="/service" component={() => <Redirect to="/service/after"/>}/>
            <Route path="/service/after" component={AfterSaleService}/>
            <Route path="/service/qa" component={QAService}/>
            <Route path="/service/case" component={CaseShow}/>
        </Switch>
    )
}
